import React, { useState, useRef } from 'react';

import TitleTab from 'components/TitleTab';
import Sidebar from './Sidebar';
import GdpGraph from './Gdp';
import Unemployment from './Unemployment';
import Cpi from './Cpi';

import './index.scss';

export default function Gdp() {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [sideBarItems, setSideBarItems] = useState([
    {
      code: 'GDP',
      title: 'Gross Domestic Product (GDP)',
    },
    {
      code: 'Unemployment',
      title: 'Unemployment',
    },
    {
      code: 'CPI',
      title: 'Prices, Consumer Price Index, All Items, Index',
    },
  ]);

  const ref = useRef(null);

  const udpateTitleBar = (itemCode, newTitle) => {
    const update = sideBarItems.map((item) => {
      if (item['code'] === itemCode) {
        item['title'] = newTitle;
      }
      return item;
    });
    setSideBarItems(update);
  };

  return (
    <div className='gdp' ref={ref} style={{ height: '100%' }}>
      <Sidebar
        sideBarItems={sideBarItems}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
      />

      <div className='gdp__main'>
        <TitleTab
          className='gdp__main__title'
          title={sideBarItems[selectedIndex]['title']}
        />
        {selectedIndex === 0 && (
          <GdpGraph udpateTitleBar={(title) => udpateTitleBar('GDP', title)} />
        )}
        {selectedIndex === 1 && <Unemployment />}
        {selectedIndex === 2 && <Cpi />}
      </div>
    </div>
  );
}
